import AddIcon from '@material-ui/icons/Add';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import AutorenewIcon from '@material-ui/icons/Autorenew';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import GavelIcon from '@material-ui/icons/Gavel';
import {RadioBoolean} from 'cl-form/FormRadio';
import {extractObjectData} from 'cl-form/utils/objectFormUtils';
import {isEmpty} from 'cl-form/validation/validators';
import {ColumnsType, selectedCount} from 'cl-table/redux/actions';
import {singleItemQuery, tableSelectionToEsQuery} from 'cl-table/utils/elasticsearchUtils';
import {getCellWithOptionsDisplayData, getColumnDisplayName} from 'cl-table/VirtualizedHelpers';
import * as _ from 'lodash';
import Amazon from 'mdi-material-ui/Amazon';
import FileDelimited from 'mdi-material-ui/FileDelimited';
import FileTableOutline from 'mdi-material-ui/FileTableOutline';
import Gavel from 'mdi-material-ui/Gavel';
import LinkIcon from 'mdi-material-ui/LinkVariant';
import LinkOffIcon from 'mdi-material-ui/LinkVariantOff';
import PackageIcon from 'mdi-material-ui/PackageVariant';
import Plus from 'mdi-material-ui/Plus';
import * as Papa from 'papaparse';
import * as Popup from 'popup-window';
import * as React from 'react';
import {browserHistory} from 'react-router';
import {getFormValues, SubmissionError} from 'redux-form';
import routes from '../../../App/routeConstants';
import {store} from '../../../App/store';
import EbayService from '../../../crazyEditor/helpers/EbayService';
import {addDynamicDialog} from '../../../crazyEditor/redux/modules/panel/panel';
import {
  getVariationAspectNames,
  getVariations,
  getVariationsInternal,
} from '../../../MyAccount/Inventory/EditProductSelectors';
import ProductAddVariationDialog from '../../../MyAccount/Inventory/ProductAddVariationDialog';
import ProductEditVariationOptionsDialog, {
  ProductEditVariationOptionsDialogComputedProps,
} from '../../../MyAccount/Inventory/ProductVariationOptionsDialog';
import {VARIATIONS_TABLE} from '../../../MyAccount/Listings/EbayListing/VariationsSection';
import {clearTaskProgress} from '../../../MyAccount/ViewDesigns/redux/modules/general';
import DeleteProductsDialog from '../../components/Dialogs/DeleteProductsDialog/DeleteProductsDialog';
import {EditColumnFormData, MappingType} from '../../components/Dialogs/EditColumnDialogs/EditColumnDialog';
import ImportAmazonCsvDialog, {
  ImportAmazonCsvFormData,
} from '../../components/Dialogs/ImportAmazonCsvDialog/ImportAmazonCsvDialog';
import ImportCsvDialog, {
  ImportCsvFormData,
  ImportCsvDialogProps,
} from '../../components/Dialogs/ImportCsvDialog/ImportCsvDialog';
import ImportProductsFromAmazonDialog, {
  ImportProductsFromAmazonFormData,
} from '../../components/Dialogs/ImportProductsFromAmazonDialog/ImportProductsFromAmazonDialog';
import ImportProductsFromEbayDialog, {
  ImportProductsFromEbayFormData,
} from '../../components/Dialogs/ImportProductsFromEbayDialog/ImportProductsFromEbayDialog';
import PublishToAmazonConfirmationDialog from '../../components/Dialogs/PublishToAmazonConfirmationDialog/PublishToAmazonConfirmationDialog';
import PublishToAmazonDialog, {
  PublishToAmazonDialogProps,
  PublishToAmazonFormData,
} from '../../components/Dialogs/PublishToAmazonDialog/PublishToAmazonDialog';
import PublishToEbayConfirmationDialog from '../../components/Dialogs/PublishToEbayConfirmationDialog/PublishToEbayConfirmationDialog';
import PublishToEbayDialog, {
  PublishToEbayDialogProps,
  PublishToEbayFormData,
} from '../../components/Dialogs/PublishToEbayDialog/PublishToEbayDialog';
import * as ConnectEbayAccountService from '../../helpers/ConnectEbayAccountService';
import LinkToProductDialog, {LinkToProductFormData} from '../../components/ProductLink/LinkToProductDialog';
import {ACTION_DISPLAY_TYPES, ActionProps} from '../ActionsManagerConsts';
import {GENERAL_ACTIONS_TYPES} from '../ActionsTypes';
import {syncSellerListings} from '../AmazonListingsActions/AmazonListingsActionsHelpers';
import {getCurrentState} from '../EbayListingsActions/currentState';
import {amazonAccountsApi, productApi, Tables, Channels, attributesApi} from 'cl-api';
import {
  adjustVariationsTableSelection,
  convertSelectionToIDs,
  createSingleVariationsByFormValues,
  generateNewVariations,
  updateVariationsInStore,
} from '../VariationsActions/VariationsActionsHelpers';
import {hasVariationsToAddDialogStoreProps} from '../VariationsActions/VariationsActionsSelectors';
import {
  createFromListings,
  setListingsLink,
  updateListingsFromProducts,
  getImportProductsCSVDestinationAttributes,
  getVariationsLinkObjects,
  getAttributeIds,
} from './GeneralActionsHelpers';
import {SectionInfo} from 'cl-form/FormSections/consts';
import AddChannelAccountDialog, {
  AddChannelAccountDialogProps,
  AddChannelAccountFormData,
} from '../../components/Dialogs/AddChannelAccountDialog/AddChannelAccountDialog';
import {updateUserData} from '../../../MyAccount/ViewDesigns/redux/modules/user';
import {removeEBayAccount} from '../../../MyAccount/ViewDesigns/redux/modules/accountPage';
import {disconnectEbayAccount} from '../../../MyAccount/ViewDesigns/helpers/preferencesHelper';
import {handleAuthResponse, launchAuth} from '../../helpers/ConnectEbayAccountService';
import DisconnectChannelAccountDialog from '../../components/Dialogs/DisconnectChannelAccountDialog/DisconnectChannelAccountDialog';
import {getAccountsConnected, getAccountsLimit} from '../../../Layout/MyAccountLayout/ApplicationLayoutSelectors';
import {clearCache, getProductsColumnsData} from '../../../MyAccount/Inventory/utils';
import {PRODUCT_ATTRIBUTES_SECTION, PRODUCT_LISTINGS_TABLE} from '../../../MyAccount/Inventory/consts';
import {ProductLinkProps} from '../../components/ProductLink/ProductLinkIcon';
import Alert from '@material-ui/core/Alert';
import EditPaidFeaturesDialog from '../../../MyAccount/AccountPage/PlanAndBilling/EditPaidFeaturesDialog';
import {INVENTORY_SYNC} from '../../../MyAccount/AccountPage/PlanAndBilling/Consts';
import CreateAttributeDialog from '../../components/Dialogs/CreateAttributeDialog/CreateAttributeDialog';
import DeleteAttributesDialog from '../../components/Dialogs/DeleteAttributesDialog/DeleteAttributesDialog';

export const GENERAL_ACTIONS_PROPS: {[actionType: string]: ActionProps} = {
  [GENERAL_ACTIONS_TYPES.OPEN_ADD_CHANNEL_ACCOUNT_DIALOG]: {
    action: (objects, ref, {channel}) => {
      return () => {
        return store.dispatch(addDynamicDialog<AddChannelAccountDialogProps>(AddChannelAccountDialog, {channel}));
      };
    },
    displayElementsProps: {
      [ACTION_DISPLAY_TYPES.RAISED_BUTTON]: {label: 'Add account', color: 'primary'},
    },
  },
  [GENERAL_ACTIONS_TYPES.ADD_CHANNEL_ACCOUNT]: {
    action: (objects, ref, {channel}) => {
      return () => {
        const state = getCurrentState();
        switch (channel) {
          case Channels.Amazon:
            const formValues: AddChannelAccountFormData = getFormValues(GENERAL_ACTIONS_TYPES.ADD_CHANNEL_ACCOUNT)(
              state
            ) as AddChannelAccountFormData;
            const url = `/amazon-accounts/register?amazon-account-name=${formValues.accountName}&amazon-site=${
              formValues.site
            }`;
            const amazonWindow = new Popup('', {name: 'Amazon Connect Window', height: 620, width: 1000});
            amazonWindow.open();
            amazonWindow.win.location.href = url;
            break;
          case Channels.EBay:
            const referenceTransactionEnabled = state.user.referenceTransactionEnabled;
            const accountsConnected = getAccountsConnected(state);
            const accountsLimit = getAccountsLimit(state);
            if (!accountsLimit || accountsConnected < accountsLimit) {
              launchAuth(status => handleAuthResponse(status, referenceTransactionEnabled));
            } else {
              ConnectEbayAccountService.handleLimitReached(referenceTransactionEnabled);
            }
        }
      };
    },
    displayElementsProps: {
      [ACTION_DISPLAY_TYPES.FLAT_BUTTON]: {label: 'Connect your account'},
    },
  },
  [GENERAL_ACTIONS_TYPES.RENEW_EBAY_TOKEN]: {
    action: () => {
      return () => {
        const state = getCurrentState();
        const referenceTransactionEnabled = state.user.referenceTransactionEnabled;
        launchAuth(status => handleAuthResponse(status, referenceTransactionEnabled));
      };
    },
    displayElementsProps: {
      [ACTION_DISPLAY_TYPES.FLAT_BUTTON]: {label: 'Renew Token', icon: <AutorenewIcon />},
    },
    getTooltip: () => `Re-authenticate your eBay token if it was changed or expired.`,
  },
  [GENERAL_ACTIONS_TYPES.OPEN_DISCONNECT_CHANNEL_ACCOUNT_DIALOG]: {
    shouldRender: _.constant(true),
    action: (objects, ref, {channel, sellerId, quantitySyncEnabled, className}) => {
      return () => {
        const text = (
          <div>
            Are you sure you want to disconnect this {channel} account? <br />
            <Alert>
              <ul className={className}>
                <li>
                  Disconnecting this account will remove any listings and settings associated with it from CrazyLister
                  (although the actual listings will remain live on {channel}).
                </li>
                {quantitySyncEnabled ? <li>Inventory sync will be turned off for this account.</li> : undefined}
                {channel === Channels.EBay ? (
                  <li>
                    CrazyLister templates will be removed from your listings and text-only descriptions will remain.
                  </li>
                ) : (
                  undefined
                )}
              </ul>
            </Alert>
          </div>
        );
        store.dispatch(addDynamicDialog(DisconnectChannelAccountDialog, {channel, sellerId, text}));
      };
    },
    displayElementsProps: {
      [ACTION_DISPLAY_TYPES.FLAT_BUTTON]: {label: 'Disconnect account', color: 'error', icon: <DeleteIcon />},
    },
  },
  [GENERAL_ACTIONS_TYPES.DISCONNECT_CHANNEL_ACCOUNT]: {
    shouldRender: _.constant(true),
    action: (objects, ref, {channel, sellerId}) => {
      return () => {
        switch (channel) {
          case Channels.Amazon:
            return amazonAccountsApi.disconnectAmazonAccount(sellerId, {credentials: 'include'});
          case Channels.EBay:
            removeEBayAccount(sellerId);
            disconnectEbayAccount(sellerId).then(response => {
              if (response.success) {
                updateUserData(response.user);
              }
            });
        }
      };
    },
    displayElementsProps: {
      [ACTION_DISPLAY_TYPES.FLAT_BUTTON]: {label: 'Disconnect account', busyLabel: 'Disconnecting...'},
    },
  },
  [GENERAL_ACTIONS_TYPES.OPEN_IMPORT_PRODUCTS_FROM_EBAY_DIALOG]: {
    action: () => {
      return () => {
        store.dispatch(addDynamicDialog(ImportProductsFromEbayDialog));
      };
    },
    displayElementsProps: {
      [ACTION_DISPLAY_TYPES.MENU_ITEM]: {label: 'Import products from eBay', icon: <GavelIcon />},
    },
  },
  [GENERAL_ACTIONS_TYPES.OPEN_IMPORT_PRODUCTS_FROM_AMAZON_DIALOG]: {
    action: () => {
      return () => {
        store.dispatch(addDynamicDialog(ImportProductsFromAmazonDialog));
      };
    },
    displayElementsProps: {
      [ACTION_DISPLAY_TYPES.MENU_ITEM]: {label: 'Import products from Amazon', icon: <Amazon />},
    },
  },
  [GENERAL_ACTIONS_TYPES.IMPORT_PRODUCTS_FROM_EBAY]: {
    action: () => {
      return () => {
        const {firstPrioritySite, secondPrioritySite, ignoreEnded, ...otherFormValues} = getFormValues(
          GENERAL_ACTIONS_TYPES.IMPORT_PRODUCTS_FROM_EBAY
        )(getCurrentState()) as ImportProductsFromEbayFormData;
        store.dispatch(clearTaskProgress(Tables.InventoryTable));
        return EbayService.refreshSellerItems({
          ...otherFormValues,
          importProps: {
            ignoreEnded,
            sitePriorities: _.filter([firstPrioritySite, secondPrioritySite]),
            activityMeta: {
              sourceType: 'eBay',
              sourceName: otherFormValues.sellerId,
              refresh: [Tables.InventoryTable, Tables.ImportTable],
              task: Tables.InventoryTable,
            },
          },
        });
      };
    },
    displayElementsProps: {
      [ACTION_DISPLAY_TYPES.FLAT_BUTTON]: {label: 'start import'},
    },
  },
  [GENERAL_ACTIONS_TYPES.IMPORT_PRODUCTS_FROM_AMAZON]: {
    action: () => {
      return () => {
        const {firstPrioritySite, secondPrioritySite, ignoreInactive, sellerId} = getFormValues(
          GENERAL_ACTIONS_TYPES.IMPORT_PRODUCTS_FROM_AMAZON
        )(getCurrentState()) as ImportProductsFromAmazonFormData;
        return syncSellerListings(sellerId, {
          createProducts: true,
          ignoreInactive,
          sitePriorities: _.filter([firstPrioritySite, secondPrioritySite]),
        });
      };
    },
    displayElementsProps: {
      [ACTION_DISPLAY_TYPES.FLAT_BUTTON]: {label: 'start import'},
    },
  },
  [GENERAL_ACTIONS_TYPES.CONNECT_EBAY_SELLER]: {
    action: (objects, ref, action) => {
      return () => {
        return launchAuth(action);
      };
    },
    displayElementsProps: {
      [ACTION_DISPLAY_TYPES.FLAT_BUTTON]: {label: `RE-AUTHENTICATE ACCOUNT`, color: 'primary'},
    },
  },
  [GENERAL_ACTIONS_TYPES.MAP_PRODUCT_PROPERTY]: {
    action: (objects, ref, {propertyName, tableName, options}) => {
      return async () => {
        const state = getCurrentState();
        const {selectedMappingType, mapValues, mappedAttribute, value, ...valueMapping} = getFormValues(
          GENERAL_ACTIONS_TYPES.MAP_PRODUCT_PROPERTY
        )(state) as EditColumnFormData;
        const productsColumns = await getProductsColumnsData();
        if (selectedMappingType === MappingType.Single) {
          if (isEmpty(value)) {
            updateListingsFromProducts(propertyName, null, tableName);
          } else {
            updateListingsFromProducts(
              propertyName,
              {
                name: _.toString(value),
                displayName: _.toString(getCellWithOptionsDisplayData(options, value)),
                mappingType: MappingType.Single,
              },
              tableName
            );
          }
        } else {
          if (_.isEmpty(mappedAttribute)) {
            updateListingsFromProducts(propertyName, null, tableName);
          } else {
            updateListingsFromProducts(
              propertyName,
              {
                name: mappedAttribute,
                displayName: getColumnDisplayName(mappedAttribute, productsColumns[mappedAttribute]),
                valueMapping,
                mappingType: mapValues ? MappingType.ValueMapping : MappingType.DirectMapping,
              },
              tableName,
              options
            );
          }
        }
      };
    },
    displayElementsProps: {
      [ACTION_DISPLAY_TYPES.FLAT_BUTTON]: {label: 'Apply'},
    },
  },
  [GENERAL_ACTIONS_TYPES.OPEN_PUBLISH_TO_AMAZON_DIALOG]: {
    action: () => {
      return () => {
        store.dispatch(addDynamicDialog<PublishToAmazonDialogProps>(PublishToAmazonDialog));
      };
    },
    displayElementsProps: {
      [ACTION_DISPLAY_TYPES.MENU_ITEM]: {label: 'Amazon', icon: <Amazon />},
    },
  },
  [GENERAL_ACTIONS_TYPES.OPEN_PUBLISH_TO_EBAY_PAGE]: {
    action: () => {
      return () => {
        const state = getCurrentState();
        const inventoryTableState = state.table[Tables.InventoryTable];
        const initParams = {
          ...(getFormValues(GENERAL_ACTIONS_TYPES.OPEN_PUBLISH_TO_EBAY_PAGE)(state) as PublishToEbayFormData),
          ..._.pick(inventoryTableState, ['filter', 'selection']),
          count: selectedCount(inventoryTableState),
        };
        browserHistory.push({
          pathname: routes.MyAccount.PublishToEbay,
          query: {initParams: JSON.stringify(initParams), selectedSellerId: initParams.sellerId},
        });
      };
    },
    displayElementsProps: {
      [ACTION_DISPLAY_TYPES.FLAT_BUTTON]: {label: 'continue', color: 'primary'},
    },
  },
  [GENERAL_ACTIONS_TYPES.OPEN_PUBLISH_TO_AMAZON_PAGE]: {
    action: () => {
      return () => {
        const state = getCurrentState();
        const inventoryTableState = state.table[Tables.InventoryTable];
        const initParams = {
          ...(getFormValues(GENERAL_ACTIONS_TYPES.OPEN_PUBLISH_TO_AMAZON_PAGE)(state) as PublishToAmazonFormData),
          ..._.pick(inventoryTableState, ['filter', 'selection']),
          count: selectedCount(inventoryTableState),
        };
        browserHistory.push({
          pathname: routes.MyAccount.PublishToAmazon,
          query: {initParams: JSON.stringify(initParams), selectedSellerId: initParams.sellerId},
        });
      };
    },
    displayElementsProps: {
      [ACTION_DISPLAY_TYPES.FLAT_BUTTON]: {label: 'continue', color: 'primary'},
    },
  },
  [GENERAL_ACTIONS_TYPES.OPEN_DELETE_PRODUCTS_DIALOG]: {
    action: () => {
      return () => {
        const state = getCurrentState();
        const inventoryTableState = state.table[Tables.InventoryTable];
        const query = tableSelectionToEsQuery(inventoryTableState.filter, inventoryTableState.selection);
        store.dispatch(addDynamicDialog(DeleteProductsDialog, {query, count: selectedCount(inventoryTableState)}));
      };
    },
    displayElementsProps: {
      [ACTION_DISPLAY_TYPES.FLAT_BUTTON]: {label: 'delete products', icon: <DeleteIcon />},
    },
  },
  [GENERAL_ACTIONS_TYPES.OPEN_DELETE_SINGLE_PRODUCTS_DIALOG]: {
    shouldRender: (objects, storeProps, additionalData) => !!additionalData,
    action: (objects, ref, additionalData) => {
      // additionalData should be the id of the product to delete
      return () => {
        store.dispatch(addDynamicDialog(DeleteProductsDialog, {query: singleItemQuery(additionalData), count: 1}));
      };
    },
    displayElementsProps: {
      [ACTION_DISPLAY_TYPES.FLAT_BUTTON]: {label: 'delete', icon: <DeleteIcon />, color: 'error'},
    },
  },
  [GENERAL_ACTIONS_TYPES.DELETE_PRODUCTS]: {
    action: (objects, ref, query) => {
      return async () => {
        const response = await productApi.deleteProducts(query, {credentials: 'include'});
        browserHistory.replace({pathname: routes.MyAccount.Inventory});
        return response;
      };
    },
    displayElementsProps: {
      [ACTION_DISPLAY_TYPES.FLAT_BUTTON]: {label: 'delete', color: 'error'},
    },
  },
  [GENERAL_ACTIONS_TYPES.OPEN_PUBLISH_TO_EBAY_CONFIRMATION_DIALOG]: {
    action: () => {
      return () => {
        store.dispatch(addDynamicDialog(PublishToEbayConfirmationDialog));
      };
    },
    displayElementsProps: {
      [ACTION_DISPLAY_TYPES.RAISED_BUTTON]: {label: 'continue', color: 'primary'},
    },
  },
  [GENERAL_ACTIONS_TYPES.OPEN_PUBLISH_TO_AMAZON_CONFIRMATION_DIALOG]: {
    action: () => {
      return () => {
        store.dispatch(addDynamicDialog(PublishToAmazonConfirmationDialog));
      };
    },
    displayElementsProps: {
      [ACTION_DISPLAY_TYPES.RAISED_BUTTON]: {label: 'continue', color: 'primary'},
    },
  },
  [GENERAL_ACTIONS_TYPES.OPEN_IMPORT_AMAZON_CSV_DIALOG]: {
    action: () => {
      return () => {
        store.dispatch(addDynamicDialog(ImportAmazonCsvDialog));
      };
    },
    displayElementsProps: {
      [ACTION_DISPLAY_TYPES.MENU_ITEM]: {
        label: 'Amazon.com products',
        secondary: 'via ASINs CSV file',
        icon: <Amazon />,
      },
    },
  },
  [GENERAL_ACTIONS_TYPES.IMPORT_AMAZON_CSV]: {
    action: () => {
      return async () => {
        store.dispatch(clearTaskProgress(Tables.InventoryTable));
        const state = getCurrentState();
        const {file} = getFormValues(GENERAL_ACTIONS_TYPES.IMPORT_AMAZON_CSV)(state) as ImportAmazonCsvFormData;
        const reader = new FileReader();
        const readerPromise = new Promise(resolve => {
          reader.onload = function() {
            resolve();
          };
        });
        reader.readAsText(file);
        await readerPromise;
        return productApi.createFromAmazonCsv(
          {
            content: reader.result as string,
            activityMeta: {
              sourceType: 'Amazon.com CSV',
              sourceName: file.name,
              refresh: [Tables.InventoryTable, Tables.ImportTable as any],
              task: Tables.InventoryTable as any,
            },
          },
          {credentials: 'include'}
        );
      };
    },
    displayElementsProps: {
      [ACTION_DISPLAY_TYPES.FLAT_BUTTON]: {label: 'start import', color: 'primary'},
    },
  },
  [GENERAL_ACTIONS_TYPES.OPEN_PUBLISH_TO_EBAY_DIALOG]: {
    action: () => {
      return () => {
        store.dispatch(addDynamicDialog<PublishToEbayDialogProps>(PublishToEbayDialog));
      };
    },
    displayElementsProps: {
      [ACTION_DISPLAY_TYPES.MENU_ITEM]: {label: 'eBay', icon: <Gavel />},
    },
  },
  [GENERAL_ACTIONS_TYPES.OPEN_IMPORT_PRODUCTS_CSV_DIALOG]: {
    action: () => {
      return async () => {
        const destinationAttributes = await getImportProductsCSVDestinationAttributes();
        const {columns} = await attributesApi.getAttributesColumns();
        store.dispatch(
          addDynamicDialog<ImportCsvDialogProps>(ImportCsvDialog, {
            destinationAttributes,
            attributesColumns: columns,
          })
        );
      };
    },
    displayElementsProps: {
      [ACTION_DISPLAY_TYPES.MENU_ITEM]: {
        label: 'Import new products',
        secondary: 'via CSV file',
        icon: <FileDelimited />,
      },
    },
  },
  [GENERAL_ACTIONS_TYPES.OPEN_UPDATE_PRODUCTS_CSV_DIALOG]: {
    action: () => {
      return async () => {
        const destinationAttributes = await getImportProductsCSVDestinationAttributes();
        const {columns} = await attributesApi.getAttributesColumns();
        store.dispatch(
          addDynamicDialog<ImportCsvDialogProps>(ImportCsvDialog, {
            initialValues: {updateExisting: RadioBoolean.true},
            destinationAttributes,
            attributesColumns: columns,
          })
        );
      };
    },
    displayElementsProps: {
      [ACTION_DISPLAY_TYPES.MENU_ITEM]: {
        label: 'Update existing products',
        secondary: 'via CSV file',
        icon: <FileTableOutline />,
      },
    },
  },
  [GENERAL_ACTIONS_TYPES.OPEN_IMPORT_PAGE]: {
    action: () => {
      return () => {
        browserHistory.push({pathname: routes.MyAccount.Import});
      };
    },
    displayElementsProps: {
      [ACTION_DISPLAY_TYPES.MENU_ITEM]: {label: 'Manage imports', icon: <CloudUploadIcon />},
    },
  },
  [GENERAL_ACTIONS_TYPES.IMPORT_INVENTORY_CSV]: {
    action: (objects, ref, additionalData) => {
      const {task} = additionalData;
      return async () => {
        store.dispatch(clearTaskProgress(task));
        const state = getCurrentState();
        const {
          file,
          ignoreBlankAttributes,
          updateOnlyEmptyAttributes,
          updateExisting,
          replaceImages,
          ...mappedProps
        } = getFormValues(GENERAL_ACTIONS_TYPES.IMPORT_INVENTORY_CSV)(state) as ImportCsvFormData;
        if (!_.find(mappedProps, prop => prop === 'SKU')) {
          throw new SubmissionError({_error: 'SKU required - please assign a CSV column to SKU.'});
        }
        const data = new Promise<Papa.ParseResult['data']>((resolve, reject) => {
          Papa.parse(file, {
            header: true,
            complete: ({data}) => {
              resolve(data);
            },
            error: reject,
            skipEmptyLines: true,
          });
        });
        return productApi.createUpdateProducts({
          options: {
            ignoreBlankAttributes,
            updateOnlyEmptyAttributes,
            replaceImages,
            updateExisting: updateExisting === RadioBoolean.true,
          },
          activityMeta: {
            sourceType: 'CSV File',
            sourceName: file.name,
            refresh: [task, Tables.ImportTable],
            task: task,
          },
          objects: _.map(await data, (sourceRow, index) => {
            const product = _.mapKeys(
              _.pickBy(sourceRow, (value, sourceKey) => mappedProps[sourceKey] && mappedProps[sourceKey] !== 'N/A'),
              (value, sourceKey) => mappedProps[sourceKey]
            );
            const Images = _.filter(
              sourceRow,
              (value, sourceKey) => mappedProps[sourceKey] && mappedProps[sourceKey] === 'Images' && !_.isEmpty(value)
            );
            if (!_.isEmpty(Images)) {
              product.Images = Images;
            }
            product.line = index + 2;
            return product;
          }),
        });
      };
    },
    displayElementsProps: {
      [ACTION_DISPLAY_TYPES.FLAT_BUTTON]: {label: 'start import', color: 'primary'},
    },
  },
  [GENERAL_ACTIONS_TYPES.OPEN_EDIT_PRODUCT_VARIATION_OPTIONS_DIALOG]: {
    shouldRender: _.constant(true),
    action: (objects, ref, sections) => {
      return () => {
        store.dispatch(
          addDynamicDialog<ProductEditVariationOptionsDialogComputedProps>(ProductEditVariationOptionsDialog, {
            fieldsInfo: _.flatten(_.map(sections, (section: SectionInfo<any>) => section.fieldsInfo)),
          })
        );
      };
    },
    displayElementsProps: {
      [ACTION_DISPLAY_TYPES.FLAT_BUTTON]: {label: 'EDIT VARIATION OPTIONS', color: 'default', icon: <EditIcon />},
    },
    objectIsOptional: true,
  },
  [GENERAL_ACTIONS_TYPES.EDIT_PRODUCT_VARIATION_OPTIONS]: {
    shouldRender: _.constant(true),
    action: () => {
      return () => {
        const state = getCurrentState();
        const formValues = extractObjectData(
          getFormValues(GENERAL_ACTIONS_TYPES.EDIT_PRODUCT_VARIATION_OPTIONS)(state)
        );
        const newVariations = generateNewVariations(formValues);
        _.forEach(getVariations(state), (prevVariation, id) => {
          if (newVariations[id]) {
            newVariations[id] = prevVariation;
          }
        });
        updateVariationsInStore(newVariations, true);
      };
    },
    displayElementsProps: {
      [ACTION_DISPLAY_TYPES.FLAT_BUTTON]: {label: 'apply', color: 'primary'},
    },
    objectIsOptional: true,
  },
  [GENERAL_ACTIONS_TYPES.DELETE_PRODUCT_VARIATIONS]: {
    action: () => {
      return async () => {
        const state = getCurrentState();
        const rows = getVariationsInternal(state);
        let idsToDelete = convertSelectionToIDs(state.table[VARIATIONS_TABLE].selection, _.keys(rows));
        const updatedVariations = _.omit(rows, idsToDelete);
        updateVariationsInStore(updatedVariations);
        adjustVariationsTableSelection(updatedVariations);
      };
    },
    displayElementsProps: {
      [ACTION_DISPLAY_TYPES.FLAT_BUTTON]: {label: 'delete variations'},
    },
    objectIsOptional: true,
  },
  [GENERAL_ACTIONS_TYPES.OPEN_ADD_PRODUCT_VARIATION_DIALOG]: {
    getStoreProps: hasVariationsToAddDialogStoreProps,
    action: () => {
      return () => {
        const tableState = getCurrentState().table[VARIATIONS_TABLE];
        const {columns} = tableState;
        store.dispatch(addDynamicDialog(ProductAddVariationDialog, {columns} as ColumnsType));
      };
    },
    displayElementsProps: {
      [ACTION_DISPLAY_TYPES.FLAT_BUTTON]: {
        label: 'ADD VARIATION',
        color: 'default',
        icon: <AddIcon />,
      },
    },
    objectIsOptional: true,
    isDisabled: (objects, {hasVariationsToAdd}) => !hasVariationsToAdd,
  },
  [GENERAL_ACTIONS_TYPES.ADD_SINGLE_PRODUCT_VARIATION]: {
    shouldRender: _.constant(true),
    action: () => {
      return () => {
        const state = getCurrentState();
        const currentVariations = getVariations(state);
        const formValues = getFormValues(GENERAL_ACTIONS_TYPES.ADD_SINGLE_PRODUCT_VARIATION)(state);
        const newVariation = createSingleVariationsByFormValues(formValues, getVariationAspectNames(state));
        updateVariationsInStore({...currentVariations, ...newVariation}, true);
      };
    },
    displayElementsProps: {
      [ACTION_DISPLAY_TYPES.FLAT_BUTTON]: {label: 'apply', color: 'primary'},
    },
    objectIsOptional: true,
  },
  [GENERAL_ACTIONS_TYPES.OPEN_NEW_PRODUCT_PAGE]: {
    action: () => {
      return () => {
        browserHistory.push({pathname: routes.MyAccount.ProductBase});
      };
    },
    displayElementsProps: {
      [ACTION_DISPLAY_TYPES.RAISED_BUTTON]: {label: 'new product', icon: <Plus />, color: 'primary'},
    },
  },
  [GENERAL_ACTIONS_TYPES.OPEN_LINK_TO_PRODUCT_DIALOG]: {
    action: (objects, ref, props: LinkToProductFormData) => {
      return () => {
        store.dispatch(addDynamicDialog(LinkToProductDialog, {...props, variant: 'link'}, true));
      };
    },
    displayElementsProps: {
      [ACTION_DISPLAY_TYPES.MENU_ITEM]: {label: 'Link to a product', icon: <LinkIcon />},
      [ACTION_DISPLAY_TYPES.INLINE_BUTTON]: {label: 'Find a matching product'},
    },
  },
  [GENERAL_ACTIONS_TYPES.OPEN_CREATE_PRODUCT_FROM_LISTING_DIALOG]: {
    action: (objects, ref, props: LinkToProductFormData) => {
      return () => {
        store.dispatch(addDynamicDialog(LinkToProductDialog, {...props, variant: 'create'}, true));
      };
    },
    displayElementsProps: {
      [ACTION_DISPLAY_TYPES.MENU_ITEM]: {label: 'Create new product', icon: <Plus />},
      [ACTION_DISPLAY_TYPES.INLINE_BUTTON]: {label: 'Create a new product'},
    },
  },
  [GENERAL_ACTIONS_TYPES.UNLINK_FROM_PRODUCT]: {
    action: (objects, ref, props: ProductLinkProps) => {
      return async () => {
        if (!_.isEmpty(props.variations)) {
          const variationsLinkData = _.map(props.variations, (variation, variationId: string) => ({
            sellerId: props.sellerId,
            SKU: null,
            channel: props.channel,
            listingId: variationId,
          }));
          return setListingsLink(variationsLinkData);
        }
        return setListingsLink([{...props, SKU: null, variations: null}]);
      };
    },
    displayElementsProps: {
      [ACTION_DISPLAY_TYPES.MENU_ITEM]: {label: 'Unlink from product', icon: <LinkOffIcon color="error" />},
    },
  },
  [GENERAL_ACTIONS_TYPES.GO_TO_PRODUCT]: {
    action: (objects, ref, {productId}) => {
      return () => {
        browserHistory.push({pathname: `${routes.MyAccount.ProductBase}/${productId}`});
      };
    },
    displayElementsProps: {
      [ACTION_DISPLAY_TYPES.MENU_ITEM]: {label: 'Go to linked product', icon: <PackageIcon />},
    },
  },
  [GENERAL_ACTIONS_TYPES.LINK_TO_PRODUCT]: {
    action: () => {
      return async () => {
        const formValues: LinkToProductFormData = getFormValues(GENERAL_ACTIONS_TYPES.LINK_TO_PRODUCT)(
          getCurrentState()
        ) as LinkToProductFormData;
        const variations = getVariationsLinkObjects(formValues);
        return _.isEmpty(variations) ? setListingsLink([formValues]) : setListingsLink(variations);
      };
    },
    displayElementsProps: {
      [ACTION_DISPLAY_TYPES.FLAT_BUTTON]: {label: 'Link to this product', color: 'primary'},
    },
  },
  [GENERAL_ACTIONS_TYPES.CREATE_PRODUCT_FROM_LISTING]: {
    action: (objects, ref, {variations}) => {
      return () => {
        const formValues: LinkToProductFormData = getFormValues(GENERAL_ACTIONS_TYPES.CREATE_PRODUCT_FROM_LISTING)(
          getCurrentState()
        ) as LinkToProductFormData;
        const variationsLinkData = getVariationsLinkObjects(formValues, variations);
        if (!_.isEmpty(variations)) {
          return createFromListings([
            {
              ..._.pick(formValues, ['sellerId', 'SKU', 'listingSKU', 'channel', 'listingId']),
              variations: variationsLinkData,
            },
          ]);
        }
        return createFromListings([formValues]);
      };
    },
    displayElementsProps: {
      [ACTION_DISPLAY_TYPES.FLAT_BUTTON]: {label: 'Create new product', color: 'primary'},
    },
  },
  [GENERAL_ACTIONS_TYPES.OPEN_UPDATE_INVENTORY_CSV_DIALOG]: {
    action: () => {
      return async () => {
        const destinationAttributes = await getImportProductsCSVDestinationAttributes();
        const {columns} = await attributesApi.getAttributesColumns();
        store.dispatch(
          addDynamicDialog<ImportCsvDialogProps>(ImportCsvDialog, {
            variant: 'update',
            supportImages: false,
            activityTask: Tables.InventoryManagementTable as any,
            sampleCSVHref: 'https://misc.crazylister.com/file-examples/inventory.csv',
            destinationAttributes,
            attributesColumns: columns,
          })
        );
      };
    },
    displayElementsProps: {
      [ACTION_DISPLAY_TYPES.MENU_ITEM]: {
        label: 'Update inventory',
        secondary: 'via CSV file',
        icon: <FileTableOutline />,
      },
    },
  },
  [GENERAL_ACTIONS_TYPES.ENABLE_SYNC]: {
    action: (objects, ref, {sellerId, enableInventorySyncFunction, inventorySyncIsPaid}) => {
      const enableFunction = () => enableInventorySyncFunction(true, sellerId);
      if (!inventorySyncIsPaid) {
        return () =>
          store.dispatch(
            addDynamicDialog(EditPaidFeaturesDialog, {
              paidFeatureName: INVENTORY_SYNC,
              onEnableFeature: enableFunction,
            })
          );
      }
      return enableFunction;
    },
    displayElementsProps: {
      [ACTION_DISPLAY_TYPES.FLAT_BUTTON]: {label: 'Enable sync', color: 'primary'},
    },
  },
  [GENERAL_ACTIONS_TYPES.SYNC_LISTINGS_FROM_CHANNELS]: {
    action: (objects, ref, productIds) => {
      return async () => {
        const activityMeta = {
          sourceType: 'Sync from channels',
          sourceName: 'Sync from channels',
          refresh: [PRODUCT_LISTINGS_TABLE, Tables.AmazonListingsTable as any],
          task: Tables.AmazonListingsTable as any,
        };
        await productApi.syncProductListings({productIds, activityMeta});
      };
    },
    displayElementsProps: {
      [ACTION_DISPLAY_TYPES.FLAT_BUTTON]: {
        label: 'Refresh from channels',
        color: 'default',
      },
    },
    getTooltip: () => `Will refresh product's listings Quantity, Price and Title from all channels`,
  },
  [GENERAL_ACTIONS_TYPES.TURN_PAID_FEATURE_OFF]: {
    action: (objects, ref, {handlePaidFeatureOk}) => {
      return () => handlePaidFeatureOk();
    },
    displayElementsProps: {
      [ACTION_DISPLAY_TYPES.FLAT_BUTTON]: {
        label: 'yes, turn it off',
        color: 'error',
      },
    },
  },
  [GENERAL_ACTIONS_TYPES.RETRY_PAYMENT]: {
    action: (objects, ref, {handlePaidFeatureOk}) => {
      return () => handlePaidFeatureOk();
    },
    displayElementsProps: {
      [ACTION_DISPLAY_TYPES.FLAT_BUTTON]: {
        label: 'retry payment',
        color: 'primary',
      },
    },
  },
  [GENERAL_ACTIONS_TYPES.CONTACT_SUPPORT]: {
    action: (objects, ref, {contactSupport}) => {
      return () => contactSupport();
    },
    displayElementsProps: {
      [ACTION_DISPLAY_TYPES.FLAT_BUTTON]: {
        label: 'contact support',
        color: 'default',
      },
    },
  },
  [GENERAL_ACTIONS_TYPES.OPEN_CREATE_ATTRIBUTE_DIALOG]: {
    action: () => {
      return () => {
        const {columns} = getCurrentState().table[Tables.AttributesTable];
        store.dispatch(addDynamicDialog(CreateAttributeDialog, {columns}));
      };
    },
    displayElementsProps: {
      [ACTION_DISPLAY_TYPES.RAISED_BUTTON]: {label: 'new attribute', icon: <Plus />, color: 'primary'},
    },
  },
  [GENERAL_ACTIONS_TYPES.OPEN_DELETE_ATTRIBUTE_DIALOG]: {
    action: () => {
      return () => {
        const attributesTableState = getCurrentState().table[Tables.AttributesTable];
        store.dispatch(addDynamicDialog(DeleteAttributesDialog, {count: selectedCount(attributesTableState)}));
      };
    },
    displayElementsProps: {
      [ACTION_DISPLAY_TYPES.FLAT_BUTTON]: {label: 'delete attribute', color: 'default'},
    },
  },
  [GENERAL_ACTIONS_TYPES.ADD_ATTRIBUTE]: {
    action: (objects, storeProps, {handleDestinationAttributeChange}) => {
      return async () => {
        const state = getCurrentState();
        const formValues = getFormValues(GENERAL_ACTIONS_TYPES.ADD_ATTRIBUTE)(state);
        const response = await attributesApi.createAttributes({
          attributes: [{...formValues, section: PRODUCT_ATTRIBUTES_SECTION}] as any,
        });
        if (handleDestinationAttributeChange && !_.isEmpty(response.result)) {
          handleDestinationAttributeChange({value: response.result[0], label: formValues['displayName']});
        }
        clearCache();
        return response;
      };
    },
    displayElementsProps: {
      [ACTION_DISPLAY_TYPES.FLAT_BUTTON]: {label: 'create', color: 'primary'},
    },
  },
  [GENERAL_ACTIONS_TYPES.DELETE_ATTRIBUTE]: {
    action: () => {
      return async () => {
        const {selection, data} = getCurrentState().table[Tables.AttributesTable];
        const idsToDelete = convertSelectionToIDs(selection, getAttributeIds(selection, data));
        const response = await attributesApi.deleteAttributes({attributeNames: idsToDelete});
        clearCache();
        return response;
      };
    },
    displayElementsProps: {
      [ACTION_DISPLAY_TYPES.FLAT_BUTTON]: {label: 'delete', color: 'error'},
    },
  },
};
